// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__7miK2","fileBtn":"File_fileBtn__352kk","closeBtn":"File_closeBtn__hp_9Y","fileSelected":"File_fileSelected__26_Nd","disabled":"File_disabled__14hGx"};